import axios from "../utils/APIUtils";
import { useEffect, useState } from "react";
import { OPPORTUNITIES_API_PATHS } from "src/constants/urlPathAndQueryParams";
import { USER_ROLE, VIEW_TYPE } from "src/constants/constants";
import { useSelector } from "react-redux";
import { getCurrentRole } from "src/slices/onBoardingSlice";

const hasPermission = (roles: string[]  | undefined) => (
  roles?.includes(USER_ROLE.VIEWER) ||
  roles?.includes(USER_ROLE.REVIEWER) ||
  roles?.includes(USER_ROLE.DOMAIN_FOCAL) ||
  roles?.includes(USER_ROLE.LEADERSHIP_USER) ||
  roles?.includes(USER_ROLE.POWER_USER) ||
  roles?.includes(USER_ROLE.ADMIN_USER)
)

export const  fetchData = async (url: string) => {
  return await axios.get<any>(url)
    .then((response) => {
        return response.data;
  }).catch(err => {
    console.log('getReasons API error ', err);
    throw err;
 });
}
export const  postData = async (url: string, payload: any) => {
  return await axios.post<any>(url, payload)
    .then((response) => {
        return response.data;
  }).catch(err => {
    console.log('getReasons API error ', err);
    throw err;
 });
}

export const useCount = (currentRole: string,roles: string[] | undefined, actionStatus: number) => {
    const INITIAL_STATE = {total_count:0};
    const [count, setCount] = useState(INITIAL_STATE);
    useEffect(()=> {
      if (!hasPermission(roles)){
        return;
      }
          const get = async () => {
            try{
               const defualtRole = roles ? roles[0] : '';
               const role = currentRole || defualtRole;
               const res = await  fetchData(`${OPPORTUNITIES_API_PATHS.actionCount}?current_role=${role}`);
               const [pendingCount] = res.rows;
               const state = pendingCount || INITIAL_STATE;
               setCount(state);
            } catch(error) {
               setCount(INITIAL_STATE);
            }
          };
          get();
    }, [roles, actionStatus,currentRole]);
    return count;
}

export const useActionItems = (currentRole: string, roles: string[] | undefined, actionStatus: number) => {
  const [actions, setAction] = useState<any>();
  useEffect(()=> {
    const defualtRole = roles ? roles[0] : '';
    const role = currentRole || defualtRole;
    if (!hasPermission(roles)) {
      return;
    }
    const post = async () => {
      try{        
        const payoload = {"page":1,"rows_per_page":3,"sort":{},"view_type": VIEW_TYPE.PENDING_ACTIONS,"filters":[] ,  "current_role": role};
         const res = await  postData(OPPORTUNITIES_API_PATHS.opportunities, payoload);
         setAction(res);
      } catch(error) {
        setAction(null);
      }
    };
    if(role)post();
    
  },[roles, actionStatus, currentRole])
return actions;
}